import { DeepPartial } from 'ia-react-core/~/interfaces/DeepPartial';
import { FormState } from 'ia-react-core/~/interfaces/FormState';
import Action from '../#Action';

export interface UpdateFormByIdOptions {
  mergeBlacklist?: object[];
}

export default class UpdateFormById extends Action {
  /** The action namespace */
  static namespace = 'Core/Form';

  /** The base action type */
  static type = 'Core/Form/UpdateFormById';

  static identifier = 'formId';

  formId: number;
  formState: DeepPartial<FormState>;
  values: object;
  options: UpdateFormByIdOptions;

  constructor(formId: number, formState: DeepPartial<FormState>, values?: object, options: UpdateFormByIdOptions = {}) {
    super();
    this.type = `${(this.constructor as typeof UpdateFormById).type}/${formId}`;
    this.formId = formId;
    this.formState = formState;
    this.values = values;
    this.options = options;
  }
}
